import { isEmpty } from 'lodash';
import moment from 'moment';
import { useNavigate, useParams } from 'react-router-dom';
import { Box } from '@chakra-ui/react';

import Breadcrumb from 'UiKit/breadcrumb';
import { useUserInfo } from 'Store/userInfo';
import { TextBold } from 'UiKit/typography';
import { Condition } from 'Component/others';
import ButtonLink from 'UiKit/button/buttonLink';
import { ChevronLeftIcon, ChevronRightIcon } from 'Asset/icon';
import FilterDatepicker from 'UiKit/filter-datepicker';

import { ReportAttendanceOperatorDetailText } from 'View/report-attendance-operator-detail/const';
import { getBreadcrumbItems } from 'View/report-attendance-operator-detail/helper/getBreadcrumbItems';
import { useReportAttendanceOperatorDetailState } from 'View/report-attendance-operator-detail/state';
import { HeadSkeleton } from 'View/report-attendance-operator-detail/component/skeleton';

import styles from './styles.module.css';

const Head = ({ data, isFetching }) => {
  const navigate = useNavigate();
  const { id, date } = useParams();
  const { roleName } = useUserInfo();

  const isOwner = roleName === 'Owner';
  const { filterState, updateFilterState } = useReportAttendanceOperatorDetailState();
  const paramsDate = moment(date, 'DD-MM-YYYY');

  const breadcrumbItems = getBreadcrumbItems({ id, date: filterState.date, paramsDate, operatorName: data?.operatorName });

  const handleChangeDate = (date) => {
    if (date) {
      const path = id ? `/report/operator-attendance/${id}/${date}` : `/report/attendance/operator/${date}`;
      updateFilterState({ date: new Date(moment(date, 'DD-MM-YYYY')) });
      navigate(path);
    }
  };

  return (
    <Box className={styles['head__container']}>
      <Breadcrumb items={breadcrumbItems} isLoading={isFetching} />
      <Condition statement={!isFetching} fallback={<HeadSkeleton />}>
        <TextBold className={styles['head__title']}>
          <Condition statement={!isOwner} fallback={moment(filterState.date || paramsDate).format('DD MMMM YYYY')}>
            {ReportAttendanceOperatorDetailText.titleText}
          </Condition>
        </TextBold>
        <Box className={styles['head__date--container']}>
          <Box className={styles['head__date--button-container']}>
            <ButtonLink
              isDisabled={isEmpty(data?.previousDate)}
              className={styles['head__date--buton']}
              data-testid="head__button--prev-date"
              onClick={() => handleChangeDate(data?.previousDate)}
            >
              <ChevronLeftIcon width="24px" height="24px" color="var(--color-neutral50)" />
            </ButtonLink>

            <ButtonLink
              isDisabled={isEmpty(data?.nextDate)}
              className={styles['head__date--buton']}
              data-testid="head__button--next-date"
              onClick={() => handleChangeDate(data?.nextDate)}
            >
              <ChevronRightIcon width="24px" height="24px" color={'var(--color-neutral50)'} />
            </ButtonLink>

            <FilterDatepicker
              borderless={true}
              icon="chevron"
              value={filterState.date || new Date(paramsDate)}
              onChange={(value) => updateFilterState({ date: value })}
            />
          </Box>
        </Box>
      </Condition>
    </Box>
  );
};

export default Head;
